import React from 'react';
import PropTypes from 'prop-types';
import { UserIcon, BuildingOfficeIcon } from '@heroicons/react/24/outline';

const COLORS = [
  'bg-red-500',
  'bg-orange-500',
  'bg-amber-500',
  'bg-yellow-500',
  'bg-lime-500',
  'bg-green-500',
  'bg-emerald-500',
  'bg-teal-500',
  'bg-cyan-500',
  'bg-sky-500',
  'bg-blue-500',
  'bg-indigo-500',
  'bg-violet-500',
  'bg-purple-500',
  'bg-fuchsia-500',
  'bg-pink-500',
  'bg-rose-500'
];

function Avatar({ name, surname, imageURL, type, size = 'md', className = '' }) {
  // Determine size classes
  const sizeClasses = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-12 w-12 text-base',
    lg: 'h-16 w-16 text-xl',
    xl: 'h-24 w-24 text-3xl'
  };

  const containerClass = `flex-shrink-0 rounded-full flex items-center justify-center font-medium text-white overflow-hidden ${sizeClasses[size]} ${className}`;

  // 1. Show Image if available
  if (imageURL) {
    return (
      <img 
        src={imageURL} 
        alt={name} 
        className={`${sizeClasses[size]} rounded-full object-cover border border-gray-100 ${className}`}
      />
    );
  }

  // 2. Calculate Initials
  const getInitials = () => {
    if (type === 'organization') {
      // For organizations: First letter of first 2 words
      const words = name.trim().split(/\s+/);
      if (words.length >= 2) {
        return (words[0][0] + words[1][0]).toUpperCase();
      } else if (words.length === 1) {
        return words[0].substring(0, 2).toUpperCase();
      }
      return <BuildingOfficeIcon className="w-1/2 h-1/2" />;
    } else {
      // For persons: First letter of Name + First letter of Surname
      const firstInitial = name ? name[0].toUpperCase() : '';
      const lastInitial = surname ? surname[0].toUpperCase() : '';
      
      if (!firstInitial && !lastInitial) {
          return <UserIcon className="w-1/2 h-1/2" />;
      }
      
      return firstInitial + lastInitial;
    }
  };

  // 3. Determine Color based on name hash
  const getColor = () => {
    const str = (name + (surname || '')).toLowerCase();
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % COLORS.length;
    return COLORS[index];
  };

  return (
    <div className={`${containerClass} ${getColor()}`}>
      {getInitials()}
    </div>
  );
}

Avatar.propTypes = {
  name: PropTypes.string,
  surname: PropTypes.string,
  imageURL: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  className: PropTypes.string
};

export default Avatar;

